import * as API from '../utilities/api';

export const CLEAR_SELECTED_PARTY_ROOMS = 'CLEAR_SELECTED_PARTY_ROOMS';
export const FETCH_PARTY_ROOMS = 'FETCH_PARTY_ROOMS';
export const RECEIVE_PARTY_ROOMS = 'RECEIVE_PARTY_ROOMS';
export const SELECT_PARTY_ROOM = 'SELECT_PARTY_ROOM';

export function fetchPartyRooms(overwrite) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.partyRoom.partyRoomsData === null || overwrite) {
        API.getPartyRooms(state.station, state.bookingLocation.selectedLocationId, state.date.selectedDate)
          .then(result => {
            dispatch(receivePartyRooms(result));
            resolve();
          })
          .catch(error => {
            console.error('Failed to get party room info: ' + error);
            reject(error);
          });
      }
      else {
        resolve();
      }
    });
  };
}

export function receivePartyRooms(partyRooms) {
  return {
    type: RECEIVE_PARTY_ROOMS,
    partyRooms
  };
}

export function selectPartyRoom(timeslotId, partyRoomId, quantity) {
  return {
    type: SELECT_PARTY_ROOM,
    timeslotId,
    partyRoomId,
    quantity
  };
}

export function clearSelectedPartyRooms() {
  return {
    type: CLEAR_SELECTED_PARTY_ROOMS
  };
}
